<template>
  <div class="materialApplicationPage" v-if="!showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantName"
          v-if="mode != 'add'"
          :required="editType"
          readonly
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          v-else
          :required="editType"
          readonly
          label="申请人："
          class="ggInput"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          @click="checkItemPicker"
          :is-link="editType"
          readonly
          class="ggInput"
          input-align="right"
          rows="1"
          autosize
        />
      </van-cell-group>
      <div v-if="isZhaodai">
        <van-cell-group class="itemSite baseNone beizhu moreText">
          <van-field
            v-model="receptionCost"
            label="招待费用（元）："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
        <van-cell-group class="itemSite baseNone beizhu moreText">
          <van-field
            v-model="receptionCostTotal"
            label="累计招待费用（元）："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
      </div>
      <!-- 项目易耗品金额 -->
      <van-cell-group
        class="itemSite baseNone moreText"
        v-if="propertyData.materialNature == '易耗品' && materialAmountShow"
      >
        <van-field
          v-model="propertyData.materialAmount"
          label="项目易耗品金额："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.code"
          input-align="right"
          clearable
          class="ggInput"
          readonly
          label="物资编号："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.materialName"
          input-align="right"
          clearable
          class="ggInput"
          readonly
          label="名称："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.materialType"
          input-align="right"
          clearable
          class="ggInput"
          label="类型："
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.materialNature"
          input-align="right"
          clearable
          class="ggInput"
          label="属性："
          readonly
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.inventory"
          type="digit"
          input-align="right"
          class="ggInput"
          clearable
          label="库存："
          readonly
        />
      </van-cell-group>
      <!-- <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.createTime"
          label="申领时间："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>-->
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.price"
          type="number"
          input-align="right"
          class="ggInput"
          clearable
          label="物品单价(元)："
          readonly
        />
      </van-cell-group>

      <van-cell-group
        class="baseNone baseSalary"
        v-if="
          propertyData.projectCode &&
          propertyData.materialNature == '易耗品' &&
          propertyData.materialChildType == 'zdyp'
        "
      >
        <van-field
          v-model="propertyData.costTypeName"
          :required="editType"
          readonly
          label="成本类型："
          :placeholder="editType ? '请选择' : ''"
          :is-link="editType"
          @click="changeCostType"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.receiveAmount"
          type="digit"
          class="ggInput"
          input-align="right"
          clearable
          @input="setAllMoney()"
          :required="editType"
          label="申领数量 ："
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.allMoney"
          class="ggInput"
          input-align="right"
          clearable
          :required="editType"
          label="申领物品总金额(元)："
          readonly
          :placeholder="editType ? '0' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          label="申领原因："
          :required="editType"
          rows="1"
          autosize
          input-align="right"
          type="textarea"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
      <!-- 项目管理 -->
      <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
        <project-view @setItems="setProject"></project-view>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        @click="checkInput()"
        :loading="btnLoading"
        :loading-text="loadingText"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput()"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput()"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 成本类型 -->
    <van-popup v-model="showCostTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="costTypeData"
        value-key="dictName"
        @cancel="showCostTypePicker = false"
        @confirm="saveCostType"
      />
    </van-popup>
    <!-- 暂无数据 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
import {
  dateFormat,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
} from "@/utils/common";
export default {
  name: "materialApplication",
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
    projectView,
  },
  data() {
    return {
      mode: "add",
      editType: false, //是否可以编辑
      propertyData: {
        applicantId: "",
        applicantName: "",
        materialName: "", //物资名称
        materialTypeName: "", //物资类型
        materialNature: "", //物资属性
        materialChildType: "", //招待类型
        inventory: "", //物资库存
        reason: "", //原因
        createTime: "", //申请时间
        receiveAmount: "", //数量
        allMoney: "", //领取物资总金额
        projectName: "", //所属项目名称
        projectCode: "", //所属项目code
        materialAmount: "", //项目物资金额
        costType: "", //成本类型
        costTypeName: "", //成本类型Name
      },
      firstContact: [], //项目联系人
      costTypeData: [],
      showCostTypePicker: false, //成本类型弹框
      isZhaodai: false,
      receptionCost: "", //招待费用
      receptionCostTotal: "", //累计招待费用
      commonId: "", //新增就是物资id，编辑查看就是物资申请Id
      showItemPicker: false, //所属项目弹框
      materialAmountShow: false, //项目物资金额 默认不显示
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      sendType: "", //判断是否在抄送列表
      loadingText: "操作中...", //	btn加载状态提示文字
      is_weixn: is_wei(), //是否为微信
      marketArchive: true, //营销封存
      technologyArchive: true, //技术封存
    };
  },
  mounted() {
    if (is_wei()) {
      document.title = "物资申请";
    }
    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.sendType = this.$route.query.sendType; // 1：在抄送列表

    this.$nextTick(() => {
      this.commonId =
        this.mode == "add"
          ? this.$route.query.zcId
          : this.$route.query.commonId; //申请Id
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
        this.propertyData.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
      }
      this.getPage();
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },
    //项目信息
    checkItemPicker() {
      if (!this.editType) {
        return false;
      }
      this.showItemPicker = true;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    setProject(data) {
      //获取所属项目
      if (data != "") {
        this.propertyData.projectCode = data.id;
        this.propertyData.projectName = data.name;
        this.firstContact = data.firstContact;
        this.marketArchive = data.marketArchive; //营销封存
        this.technologyArchive = data.technologyArchive; //技术封存
        this.setMaterialAmount();
        this.getCostInfo(data.id);
        this.getCostTypeList();
      }
      this.showItemPicker = false;
    },
    async getCostTypeList() {
      let baseData = [];
      let baseList = await getDictList("costType");

      for (let item of baseList) {
        console.log(item, "item");
        if (item.dictCode == "yxcb") {
          // this.isFirstContact && !this.marketArchive ? arr.push(item) : ''
          if (this.firstContact && this.firstContact[0]) {
            this.firstContact.forEach((userItem) => {
              if (userItem == this.userinfo.id && !this.marketArchive) {
                baseData.push(item);
              }
            });
          }
        } else if (item.dictCode == "jscb") {
          (this.userinfo.deptType == "jsbg" || this.userinfo.deptType == "tbbg") && !this.technologyArchive
            ? baseData.push(item)
            : "";
        } else if (item.dictCode == "tbcb") {
          this.userinfo.deptType == "tbbg" ? baseData.push(item) : "";
        } else if (
          this.userinfo.deptType != "jsbg" &&
          this.userinfo.deptType != "yxbg"
        ) {
          baseData.push(item);
        }
      }
      console.log(baseData);
      // if (this.firstContact && this.firstContact[0]) {
      //   this.firstContact.forEach((userItem) => {
      //     if (userItem == this.userinfo.id) {
      //       baseList.forEach((item) => {
      //         if (item.dictCode == "yxcb") {
      //           baseData.push(item);
      //         }
      //       });
      //     }
      //   });
      // } else if (this.userinfo.deptType == "jsbg") {
      //   baseList.forEach((item) => {
      //     if (item.dictCode == "jscb") {
      //       baseData.push(item);
      //     }
      //   });
      // } else if (this.userinfo.deptType == "tbbg") {
      //   baseList.forEach((item) => {
      //     if (item.dictCode == "tbbg" || item.dictCode == "glcb") {
      //       baseData.push(item);
      //     }
      //   });
      // } else {
      //   baseList.forEach((item) => {
      //     if (item.dictCode == "glcb") {
      //       baseData.push(item);
      //     }
      //   });
      // }

      this.costTypeData = baseData;
    },
    /*成本类型*/
    changeCostType() {
      if (this.editType) {
        this.showCostTypePicker = true;
      }
    },
    /*保存*/
    saveCostType(data) {
      // console.log(data);
      this.$set(this.propertyData, "costType", data.dictCode);
      this.$set(this.propertyData, "costTypeName", data.dictName);
      this.showCostTypePicker = false;
    },
    getPage() {
      if (this.mode == "add") {
        this.initPage();
      } else {
        this.materialAmountShow = true;
        this.materialPage();
      }
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.materialApply
        .detailsMaterial(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let time = dateFormat(new Date());
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.isZhaodai =
              res.data.materialChildType == "zdyp" ? true : false;
            this.propertyData.createTime = time;
            _this.propertyData.materialNature =
              _this.propertyData.materialNature == "yhp"
                ? "易耗品"
                : "固定资产";
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    materialPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.materialApply
        .detailsProcurement(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.firstContact = res.data.firstContact;
            _this.isZhaodai =
              res.data.materialChildType == "zdyp" ? true : false;
            _this.propertyData.code = _this.propertyData.materialCode;
            _this.propertyData.materialNature =
              _this.propertyData.materialNature == "yhp"
                ? "易耗品"
                : "固定资产";
            _this.propertyData.createTime =
              _this.propertyData.createTime.substr(0, 10);
            this.getCostInfo(res.data.projectId);
            // if (
            //   _this.mode == "edit" &&
            //   _this.propertyData.verifyStatus != "deny"
            // ) {
            //   this.propertyData.inventory =
            //     Number(this.propertyData.inventory) +
            //     Number(this.propertyData.receiveAmount);
            // }
            if (
              _this.propertyData.verifyStatus == "deny" ||
              _this.propertyData.verifyStatus == "hold"
            ) {
              console.log(_this.propertyData.verifyStatus);
            } else {
              _this.propertyData.inventory =
                Number(_this.propertyData.inventory) +
                Number(_this.propertyData.receiveAmount);
            }
            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
            _this.propertyData.projectCode = res.data.projectId;
            _this.setMaterialAmount();
            _this.propertyData.allMoney = (
              _this.propertyData.receiveAmount * _this.propertyData.price
            ).toFixed(2);
          } else {
            if (res.data == null) {
              let text = "资产已被删除";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    setAllMoney() {
      //获取领取物资总金额
      if (
        Number(this.propertyData.receiveAmount) >
        Number(this.propertyData.inventory)
      ) {
        this.$toast("申领数量不能大于库存数量");
        this.propertyData.allMoney = 0;
      } else {
        this.propertyData.allMoney = (
          this.propertyData.receiveAmount * this.propertyData.price
        ).toFixed(2);
      }
    },
    setMaterialAmount() {
      //获取项目物资金额
      let _this = this;
      _this.$api.material.materialApply
        .getProjectMaterialAmount({ projectId: this.propertyData.projectCode })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            this.propertyData.materialAmount = res.data.materialAmount;
            this.materialAmountShow = true;
          } 
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目id获取成本信息I
    getCostInfo(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .getCostInfo({
          projectId: id,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data, "CostInfo");
            _this.receptionCost = res.data.receptionCost
              ? Number(res.data.receptionCost).toFixed(2)
              : ""; // 招待费用
            _this.receptionCostTotal = res.data.receptionCostTotal
              ? Number(res.data.receptionCostTotal).toFixed(2)
              : ""; // 累计招待费用
            // _this.marketingCost = res.data.marketingCost
            //   ? Number(res.data.marketingCost).toFixed(2)
            //   : ""; // 营销成本
            // _this.marketingCostTotal = res.data.marketingCostTotal
            //   ? Number(res.data.marketingCostTotal).toFixed(2)
            //   : ""; // 累计营销成本
            // _this.technicalCost = res.data.technicalCost
            //   ? Number(res.data.technicalCost).toFixed(2)
            //   : ""; // 技术成本
            // _this.technicalCostTotal = res.data.technicalCostTotal
            //   ? Number(res.data.technicalCostTotal).toFixed(2)
            //   : ""; // 累计技术成本
            // _this.bidCostTotal = res.data.bidCostTotal
            //   ? Number(res.data.bidCostTotal).toFixed(2)
            //   : ""; // 累计投标成本
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    validate() {
      //校验
      let _this = this;
      if (
        this.propertyData.materialNature == "易耗品" &&
        this.propertyData.materialChildType == "zdyp"
      ) {
        if (
          this.propertyData.reason == "" ||
          this.propertyData.receiveAmount == "" ||
          this.propertyData.projectCode == "" ||
          this.propertyData.costType == ""
        ) {
          _this.$toast("请完善表单信息");
          return false;
        }
        return true;
      } else {
        if (
          this.propertyData.reason == "" ||
          this.propertyData.receiveAmount == "" ||
          this.propertyData.projectCode == ""
        ) {
          _this.$toast("请完善表单信息");
          return false;
        }
        return true;
      }
    },
    checkInput() {
      //确定
      let _this = this;
      if (this.validate()) {
        let updateData = {
          annexes: null,
          applyGetMaterialId: _this.propertyData.applyGetMaterialId,
          materialGetId: _this.propertyData.materialGetId,
          materialId: _this.propertyData.materialId,
          allMoney: _this.propertyData.allMoney,
          reason: _this.propertyData.reason,
          receiveAmount: _this.propertyData.receiveAmount,
          projectId: _this.propertyData.projectCode,
          costType: _this.propertyData.costType,
          costTypeName: _this.propertyData.costTypeName,
        };
        let addData = [
          {
            materialCode: _this.propertyData.code,
            materialId: _this.propertyData.id,
            materialName: _this.propertyData.materialName,
            reason: _this.propertyData.reason,
            allMoney: _this.propertyData.allMoney,
            receiveAmount: _this.propertyData.receiveAmount,
            projectId: _this.propertyData.projectCode,
            costType: _this.propertyData.costType,
            costTypeName: _this.propertyData.costTypeName,
          },
        ];
        let params = _this.mode == "add" ? addData : updateData;
        _this.btnLoading = true;
        _this.$api.material.materialApply
          .addEditProcurement(_this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = _this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.materialApply
            .deleteRecall(
              _this.propertyData.verifyStatus,
              _this.propertyData.applyGetMaterialId
            )
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          this.propertyData.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.materialApplicationPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    border-bottom: 1px solid #f6f6f6;
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone.moreText {
    .van-cell__title {
      width: 200px;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>